import { SyntheticEvent, createContext } from 'react';
import { TabValueType } from './interfaces';

export interface TabsContextValue {
  onSelected: (event: SyntheticEvent | null, value: TabValueType) => void;
  onClick: (value: TabValueType) => void;
  selectedTab: TabValueType;
  panelComponentMountMap: Map<TabValueType, boolean>;
}

const DEFAULT_CONTEXT_VALUE: TabsContextValue = {
  onSelected: () => {},
  onClick: () => {},
  selectedTab: 0,
  panelComponentMountMap: new Map()
};

export const TabsContext = createContext<TabsContextValue>(DEFAULT_CONTEXT_VALUE);
